import { PaginationAndColumnVisibilityHoc } from "@shared/components";
import InvoiceDataGrid from "../components/InvoiceDataGrid";
import InvoiceHeader from "../components/InvoiceHeader";
import { ColumnOptions, DefaultHiddenColumns } from "../utils/constants";
import { InvoicePartiesProps } from "../utils/types";

const InvoiceParties = ({
  visibleColumns,
  setVisibleColumns,
  paginationModel,
  setPaginationModel,
}: InvoicePartiesProps) => {
  return (
    <>
      <InvoiceHeader
        setPaginationModel={setPaginationModel}
        visibleColumns={visibleColumns}
        setVisibleColumns={setVisibleColumns}
      />
      <InvoiceDataGrid
        visibleColumns={visibleColumns}
        setPaginationModel={setPaginationModel}
        paginationModel={paginationModel}
      />
    </>
  );
};

// Map column options to match the expected format in HOC
const transformedColumnOptions = ColumnOptions.map((option) => ({
  ...option,
  field: option.value,
}));

const TransformedInvoiceParties = PaginationAndColumnVisibilityHoc(
  InvoiceParties,
  {
    columnOptions: transformedColumnOptions,
    defaultHiddenColumns: DefaultHiddenColumns,
    storageKey: "invoiceVisibleColumns",
  }
);

export default TransformedInvoiceParties;
